import { ChangeDetectionStrategy, Component, computed, signal, ViewEncapsulation } from '@angular/core';
import {
    IOnboardingReportData,
    IOnboardingReportOnboarding,
    IOnboardingReportParameter,
    IOnboardingReportSummary,
} from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report';
import { FiOnboardingReportDetailsBase } from '../fi-onboarding-report-details-base';

@Component({
    selector: 'fi-total-onboardings-details',
    templateUrl: './fi-total-onboardings-details.component.html',
    styleUrl: './fi-total-onboardings-details.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-total-onboardings-details' },
    standalone: false,
})
export class FiTotalOnboardingsDetailsComponent extends FiOnboardingReportDetailsBase {
    private _reportData = signal<IOnboardingReportData>(undefined);
    protected onboardings = computed<IOnboardingReportOnboarding[]>(() => this._reportData()?.Onboardings ?? []);
    protected locationsSummary = computed<IOnboardingReportSummary>(
        () => this._reportData()?.LocationsSummary ?? undefined,
    );
    // protected participantsSummary = computed<IOnboardingReportSummary>(() => this._reportData()?.ParticipantsSummary ?? undefined);

    protected loadReportData() {
        const parameter = this.getReportParameter();
        this.fiOnboardingReportService.getReportData(parameter).then((result: IOnboardingReportData) => {
            this._reportData.set(result);
            this.checkLoadAvailableBusinessUnits();
        });
    }
    private getReportParameter(): IOnboardingReportParameter {
        const parameter = this.fiOnboardingReportHelperService.getReportParameter({
            widget: this.widget,
            filter: this.currentFilter,
            loadOnboardings: true,
            // loadParticipantsSummary: true,
            loadLocationsSummary: true,
        });
        parameter.SearchText = this.searchText;
        return parameter;
    }

    protected checkLoadAvailableBusinessUnits() {
        const availableItemsByData =
            this.fiOnboardingReportTableFilterHelperService.getAvailableUnitsAreasBusinessAreas(
                this.availableItems.Onboardings,
                this.currentFilter.OnboardingIds,
                this.currentFilter,
                this.availableItems,
                { hideDeactivatedUnits: true },
            );
        this.availableItemsByDataChange.emit(availableItemsByData);
    }
}
